export default {
	add: 'إضافة وقوع وظيفي',

	addRecordDialog: 'إضافة وقوع وظيفي',
	terminationDialog: 'إنفكاك',

	headers: {
		record: 'العملية',
		date: 'التاريخ',
		section: 'القسم',
		details: 'التفاصيل',
	},
	roleTypes: {
		MovedToSection: 'نقل الى قسم',
		EndAssignmentSection: 'تسريح من قسم',
		SetSection: 'إضافة لقسم',
		Stabilizing: 'تثبيت',
		TemporaryAppointment: 'تعين مؤقت',
		ChangingJobTitle: 'تغير المسمى الوظيفي',
		Breakup: 'انفكاك',
		ChangePermanentSystem: 'تغير نظام الدوام',
		ChangeSalary: 'تغير شريحة الراتب',
	},
	addRecord: {
		tabs: {
			first: 'القسم والمسمى',
			salary: 'الراتب',
			attendance: 'الدوام',
			active: 'تعديل',
		},
		section: 'القسم',
		oldSection: 'القسم القديم',
		newSection: 'القسم الجديد',
		role: 'المسمى',
		oldRole: 'المسمى القديم',
		newRole: 'المسمى الجديد',
		type: 'النوع',
		cause: 'السبب',
		duration: 'المدة',
		salary: {
			chipNo: 'رقم الشريحة',
			chipValue: 'اساس الراتب',
			academic: 'المؤهل العلمي',
			practical: 'الخبرة العملية',
			quality: 'بدل كفاءة',
			responsibility: 'بدل مسؤولية',
			inflation: 'بدل غلاء معيشيي',
			food: 'بدل طعام',
			travel: 'بدل سفر',
			seniority: 'الأقدمية الوظيفية',
			penalty: 'مكافئات وعقوبات',
		},
	},
};
